import { Modal, Backdrop, Fade, Typography } from '@mui/material';
import React from 'react';
import PropVuLogo from '../../icons/PropVuLogo';
import ModalContentWrapper from '../ModalContentWrapper';

interface IProps {
  message: string;
  isModalOpen?: boolean;
  handleClose?: any;
}

const InformationModal = ({
  message,
  handleClose,
  isModalOpen = true,
}: IProps) => (
  <Modal
    open={isModalOpen}
    onClose={handleClose}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 300,
      },
    }}>
    <Fade in={isModalOpen}>
      <div>
        <ModalContentWrapper>
          <PropVuLogo
            sx={{ width: '12.5rem', height: 'auto', objectFit: 'contain' }}
          />
          <Typography fontWeight={500} textAlign="center">
            {message}
          </Typography>
        </ModalContentWrapper>
      </div>
    </Fade>
  </Modal>
);

export default InformationModal;
